import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "./FindAttributeOnSiteInfo";
import {contentSlicer, processContent, advanceDescriptionCompiler} from "./ContentFunctions";

const baseMethodsFunctions = {
    computed: {
        ...mapGetters({
            siteInfos: "SiteInfo/getSiteInfos"
        })
    },
    methods: {
        findAttributeOnSiteInfo,
        processContent,
        contentSlicer,
        advanceDescriptionCompiler,
        findLinkOnContent(content) {
            if (content == undefined) return ''
            var urlRegex = /https?:\/\/[^<]+/g;
            let result = ''
            content.replace(urlRegex, function (url) {
                result = url;
            })
            return result
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        dashboardLinkToSiteLink(routeName, params) {
            let routeData = this.$router.resolve({name: routeName, params: params});
            const baseLink = this.findAttributeOnSiteInfo('site_link')[0];
            return `${baseLink}${routeData.href}`
        },
        userPublicName(user) {
            if (user == null || user == undefined) {
                return ''
            }
            if (Object.keys(user).indexOf('public_name') > -1 && user.public_name != null && user.public_name.length > 0) {
                return user.public_name
            }
            return `${user.name} ${user.last_name}`
        }
    },
    watch: {
        '$route': {
            handler: function () {
                this.scrollTop()
            },
        },
    },
};

export default baseMethodsFunctions;
